import PropTypes from 'prop-types';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Iconify from 'src/components/iconify';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import { useBoolean } from 'src/hooks/use-boolean';
import { MenuItem } from '@mui/material';
import { dateformation } from 'src/components/date-format-mdy';

// ----------------------------------------------------------------------
export default function UserTableRow({ row, selected, onEditRow, onSelectRow, onDeleteRow, currentItem, serialNumber, chartsAccountList }) {
  const { user, ip_address, created_at,action } = row;
  const popover = usePopover();
  const confirm = useBoolean();

  return (
    <>
      <TableRow hover selected={selected} >
        
        <TableCell>{serialNumber}</TableCell>
        <TableCell>{user?.id}</TableCell>
        <TableCell>{user?.name}</TableCell>
        <TableCell>{user?.email}</TableCell>
        <TableCell>{dateformation(created_at)}</TableCell>
        <TableCell>{ip_address}</TableCell>
        <TableCell>{action}</TableCell>
        {/* <TableCell align="center" sx={{ px: 1, whiteSpace: 'nowrap' }}>
          <IconButton color={popover.open ? 'inherit' : 'default'} onClick={popover.onOpen}>
            <Iconify icon="eva:more-vertical-fill" />
          </IconButton>
        </TableCell> */}
      </TableRow >
      <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        arrow="right-top"
        sx={{ width: 140 }}
      >
        <MenuItem
          onClick={() => {
            confirm.onTrue();
            popover.onClose();
          }}
          sx={{ color: 'error.main' }}
        >
          <Iconify icon="solar:trash-bin-trash-bold" />
          Delete
        </MenuItem>
        <MenuItem
          onClick={() => {
            onEditRow(row);
          }}
        >
          <Iconify icon="solar:pen-bold" />
          Edit
        </MenuItem>
      </CustomPopover>
    </>
  );
}
UserTableRow.propTypes = {
  onDeleteRow: PropTypes.func,
  onEditRow: PropTypes.func,
  onSelectRow: PropTypes.func,
  row: PropTypes.object,
  selected: PropTypes.bool,
};